import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  HedWrapper,
  TilesWrapper,
} from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles.styles';
import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import H from '@zola/zola-ui/src/typography/Headings';

export const Container = styled.div`
  width: 100%;
  padding: ${SPACING.S24};
  ${MEDIA_QUERY.TABLET} {
    padding: 56px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding: 56px;
  }
  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    padding: 64px;
  }
  ${TilesWrapper}, ${HedWrapper} {
    padding-left: 0 !important;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.S8};
  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
    margin-top: ${SPACING.S32};
  }
  ${MEDIA_QUERY.TABLET} {
    margin-top: ${SPACING.LG};
  }
`;

export const Tile = styled.a`
  border-radius: 16px;
  height: 150px;
  width: 150px;
  object-fit: cover;
  flex: 0 0 auto;
  display: 'flex';
  align-items: 'center';
  justify-content: 'center';
  overflow: hidden;
  ${MEDIA_QUERY.TABLET} {
    height: 182px;
    width: 182px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    height: 270px;
    width: 270px;
  }
  ${MEDIA_QUERY.DESKTOP_XL} {
    height: 350px;
    width: 350px;
  }
  img {
    height: 100% !important;
    width: 100% !important;
  }
`;

export const marginRight = css`
  margin-right: ${SPACING.S8};
`;

export const StyledH3 = styled(H.Title3)`
  ${FONT.textSizeRegular(FONT.FONT_SIZE_LARGER)}
`;
